const WorldData = require('./world');

module.exports = WorldData;



// WEBPACK FOOTER //
// ./src/index.js